import asObject from 'utils/objects/asObject.util';

const withOptions = fn => (options, ...extra) => fn(asObject(options), ...extra);

// noinspection JSUnusedGlobalSymbols
export default withOptions;
